import { render, staticRenderFns } from "./blogs.vue?vue&type=template&id=a520804a&"
import script from "./blogs.vue?vue&type=script&lang=js&"
export * from "./blogs.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports